import { preload } from './modules/preload'
import { nav } from './modules/nav'
import { slider } from './modules/slider'
import { toggleItem } from './modules/toggleItem'
import { counter } from './modules/counter'
import { lightbox } from './modules/lightbox'
import { openFilter } from './modules/openFilter'
import { onScroll } from './modules/onScroll'
import { dialog } from './modules/dialog'
import { gsap } from './modules/gsap'
import { popups } from './modules/popups'
import { bannerForms } from './modules/bannerForms'
import { regex } from './modules/regex'

window.onload = function () {
	slider()
	onScroll()
	preload()
	nav()
	openFilter()
	lightbox()
	toggleItem()
	counter()
	dialog()
	gsap()
	popups()
	bannerForms()
	regex()
	// If BG Color is not White
	// if (window.getComputedStyle(document.body).getPropertyValue('--bg-pri') && window.getComputedStyle(document.body).getPropertyValue('--bg-pri') != '#fff') {
	// 	document.querySelector('meta[name="theme-color"]').setAttribute('content', window.getComputedStyle(document.body).getPropertyValue('--bg-pri'))
	// }
}
